import React from 'react';
import LongText from '../Elements/LongText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import LookupText from '../Elements/LookupText';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';

export default class TpClientInvoiceLineItem {
  constructor(item) {
    if (item === undefined) {
      this.TpClientInvoiceId = '';
      this.LineItemId = '';
      this.Name = '';
      this.InitialTotalDue = '';
      this.LineItemCredit = '';
      this.Outstanding = '';
      this.OutstandingVat = '';
      this.OutstandingReimb = '';
      this.OutstandingReimbVat = '';
      this.TpClientInvoiceId = '';
      this.CurrencyCode = '';
      this.ProjectId = '';
      this.ServiceId = '';
      this.OpportunityId = '';
      this.LineItemTypeId = '';
      this.InternalLineItemTypeId = '';
      this.LineItem = '';
      this.AdHocInvoiceGroup = '';

      this.Tax = '';
    } else {
      this.TpClientInvoiceId = item.tpClientInvoiceId;
      this.LineItemId = item.lineItemId;
      this.Name = item.name;
      this.InitialTotalDue = item.initialTotalDue;
      this.LineItemCredit = item.lineItemCredit;
      this.Outstanding = item.outstanding;
      this.OutstandingVat = item.outstandingVat;
      this.OutstandingReimb = item.outstandingReimb;
      this.OutstandingReimbVat = item.outstandingReimbVat;
      this.TpClientInvoiceId = item.tpClientInvoiceId;
      this.CurrencyCode = item.currencyCode;
      this.ProjectId = item.projectId;
      this.ServiceId = item.serviceId;
      this.OpportunityId = item.opportunityId;
      this.LineItemTypeId = item.lineItemTypeId;
      this.InternalLineItemTypeId = item.internalLineItemTypeId;
      this.LineItem = item.lineItem;
      this.AdHocInvoiceGroup = item.adHocInvoiceGroup;

      this.Tax = item.tax;
      this.CurrentTotalFee = item.currentTotalFee;
      this.Description = item.name;
      this.ProjectName = item.projectName;
    }
    this.Selected = false;
  }

  static nameOfTheItemDetailList() {
    return 'Third-Party Client Invoice Line Item Details';
  }

  static MoneyFields = [
    'InitialTotalDue',
    'Outstanding',
    'LineItemCredit',
    'OutstandingVat',
    'OutstandingReimb',
    'OutstandingReimbVat',
    'Tax',
    'CurrentTotalFee',
  ];

  static Currency() {
    return 'CurrencyCode';
  }

  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return '';
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'TpClientInvoiceId', label: 'Bare Invoice #', className: 'text-left' },
        { name: 'CurrencyCode', label: 'Currency', className: 'text-left' },
        { name: 'InitialTotalDue', label: 'Client Fee', className: 'text-left' },
        {
          name: (item) => (
            <LookupText
              lookupId={42}
              value={item.LineItemTypeId}
            />
          ),
          label: 'Type',
          className: 'text-left',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={42}
              value={item.InternalLineItemTypeId}
            />
          ),
          label: 'Internal Type',
          className: 'text-left',
        },
        { name: 'ProjectName', label: 'Project', className: 'text-left' },
        {
          name: 'Description',
          label: 'Description',
          className: 'text-left',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        { name: 'InitialTotalDue', label: 'Initial Total', className: 'text-left' },
        { name: '', label: '' },
        { name: '', label: '' },
        { name: 'LineItemCredit', label: 'Credit', className: 'text-left' },
        { name: '', label: '' },
        { name: '', label: '' },
        { name: 'Tax', label: 'Tax', className: 'text-left' },
        { name: '', label: '' },
        { name: '', label: '' },
        { name: 'CurrentTotalFee', label: 'Current Due', className: 'text-left' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: TpClientInvoiceLineItem.getSelectedCellHeader,
        orderById: '',
        data: TpClientInvoiceLineItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      { label: 'Name', orderById: 'Name', data: TpClientInvoiceLineItem.getNameCellContent, minWidth: 40 },
      { label: 'Ad-Hoc Invoice Group', orderById: 'AdHocInvoiceGroup', data: 'AdHocInvoiceGroup', minWidth: 20 },
      {
        label: 'Type',
        orderById: 'LineItemType',
        data: (item) =>
          !item.LineItemTypeId ? (
            'Assignment'
          ) : (
            <LookupText
              lookupId={42}
              value={item.LineItemTypeId}
            />
          ),
        minWidth: 20,
      },
      {
        label: 'Internal Type',
        orderById: 'InternalLineItemType',
        data: (item) =>
          !item.InternalLineItemTypeId ? (
            ''
          ) : (
            <LookupText
              lookupId={42}
              value={item.InternalLineItemTypeId}
            />
          ),
        minWidth: 20,
      },
      { label: 'Initial Total', orderById: 'InitialTotalDue', data: 'InitialTotalDue', minWidth: 10 },
      { label: 'Credit', orderById: 'LineItemCredit', data: 'LineItemCredit', minWidth: 10 },
      { label: 'Outstanding', orderById: 'Outstanding', data: 'Outstanding', minWidth: 10 },
      {
        label: 'Fee Tax',
        orderById: 'OutstandingVat',
        data: 'OutstandingVat',
        minWidth: 10,
      },
      {
        label: 'Reimbursement Tax',
        orderById: 'OutstandingReimbVat',
        data: 'OutstandingReimbVat',
        minWidth: 10,
      },
      { label: 'Line Item ID', orderById: 'LineItemId', data: 'LineItemId', minWidth: 10 },
      {
        label: ' ',
        orderById: '',
        data: TpClientInvoiceLineItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }
  static getNameCellContent(item) {
    return (
      <LongText
        text={item.Name ? item.Name : ' '}
        maxLength={100}
      />
    );
  }
  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={TpClientInvoiceLineItem.selectedStatus()}
          onChange={(e) => {
            TpClientInvoiceLineItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            TpClientInvoiceLineItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static clickOnSelect(item, selected) {}

  static selectedStatus() {
    return false;
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            iconName: 'fa-solid fa-edit',
            roleKey: 'edit_invoicelineitem',
            onClick: () => TpClientInvoiceLineItem.editFunction(item.CiId, item),
            disabled: TpClientInvoiceLineItem.isDisabled(item),
            hide: TpClientInvoiceLineItem.isHidden(),
          },
        ]}
      />
    );
  }

  static editFunction(id, item) {
    alert('Empty Function');
  }

  static isDisabled(item) {
    return true;
  }

  static isHidden() {
    return false;
  }
}
